/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './CasePaymentInformation.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import PaymentAmount from './PaymentAmount'
import {
  editCaseAction,
  paymentAmountAction,
  addCaseAction,
  minPaymentAmountAction,
  caseSotIdAction,
  caseTypeAction,
  receiptDetailAction,
  editCaseNumberAction,
} from 'redux/actions'
import BackNextButtons from 'shared/components/BackNextButtons.jsx'
import BackAnchor from '../../../../shared/components/BackAnchor'
import InfoDisplay from '../../CasesList/components/InfoDisplay'

const CasePaymentInformationView = ({ t, i18n, setIsError }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const {
    editCaseNumber,
    caseNumber,
    minPaymentAmount,
    paymentAmount,
    paymentAmountFull,
    cases,
    amountOwing,
    caseSotId,
    receiptDetail,
    caseType,
  } = useSelector((state) => state.app)

  const [selectedOption, setSelectedOption] = useState('')
  const [selectedOptionValid, setSelectedOptionValid] = useState('')
  const [paymentAmountValid, setPaymentAmountValid] = useState('')
  const [paymentAmountErrorPart1, setPaymentAmountErrorPart1] = useState('case_payment_information.payment_amount_error')
  const [paymentAmountErrorNumber, setPaymentAmountErrorNumber] = useState('')
  const [paymentAmountErrorPart2, setPaymentAmountErrorPart2] = useState('')

  const backNextProps = {
    prevText: t('case_payment_information.back'),
    prevURL:
      editCaseNumber !== '' && cases.length > 0
        ? `/${i18n.language}${t('routes.listed_cases')}`
        : `/${i18n.language}${t('routes.case_info')}`,
    nextText: t('case_payment_information.continue_to_contact_info'),
  }

  useEffect(() => {
    try {
      if (caseNumber === '' && editCaseNumber === '') {
        history.push(`/${i18n.language}${t('routes.case_info')}`)
      } else {
        let caseData = getPaymentAmount()
        const amount = caseData['paymentAmount'] ? caseData['paymentAmount'] : paymentAmount
        if (amount) {
          setSelectedOption(amountOwing === amount ? 'full' : 'partial')
        }
        dispatch(paymentAmountAction(amount))
        if (editCaseNumber) {
          dispatch(minPaymentAmountAction(caseData['minPaymentAmount']))
          dispatch(caseTypeAction(caseData['caseType']))
          dispatch(receiptDetailAction(caseData['receiptDetail']))
          dispatch(caseSotIdAction(caseData['caseSotId']))
        }
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [])

  const getPaymentAmount = () => {
    try {
      let caseData = cases.filter((caseInfo) => caseInfo.caseNumber === editCaseNumber)
      if (caseData.length > 0 && caseData[0]['paymentAmount'] && caseData[0]['minPaymentAmount']) {
        return caseData[0]
      }
      return ''
    } catch (err) {
      console.log(err)
    }
  }

  const onNext = () => {
    try {
      if (paymentAmountFull === 'final') {
        history.push(`/${i18n.language}${t('routes.contact_info')}`)
      } else {
        if (!selectedOption) {
          setSelectedOptionValid(false)
        }
        // if (selectedOption === 'full' || validateFields()) {
        if (validateFields()) {
          let currentCaseNumber = editCaseNumber
          if (currentCaseNumber === '') {
            const caseInfo = cases.filter((c) => c.caseNumber === caseNumber)
            if (caseInfo.length === 1) {
              currentCaseNumber = caseInfo[0].caseNumber
              dispatch(editCaseNumberAction(currentCaseNumber))
            }
          }
          if (currentCaseNumber) {
            dispatch(
              editCaseAction({
                caseNumber: currentCaseNumber,
                amountOwing,
                paymentAmount,
                minPaymentAmount: minPaymentAmount,
                paymentAmountFull: selectedOption,
                caseSotId,
                receiptDetail,
                caseType,
              })
            )
          } else {
            dispatch(
              addCaseAction({
                caseNumber,
                amountOwing,
                paymentAmount,
                minPaymentAmount: minPaymentAmount,
                paymentAmountFull: selectedOption,
                caseSotId,
                receiptDetail,
                caseType,
              })
            )
          }
          dispatch(editCaseNumberAction(''))
          history.push(`/${i18n.language}${t('routes.contact_info')}`)
        }
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const addAnotherCase = () => {
    if (paymentAmountFull === 'final') {
      history.push(`/${i18n.language}${t('routes.case_info')}`)
    } else {
      if (!selectedOption) {
        setSelectedOptionValid(false)
      }
      // if (selectedOption === 'full' || validateFields()) {
      if (validateFields()) {
        dispatch(
          addCaseAction({
            caseNumber,
            amountOwing,
            paymentAmount,
            minPaymentAmount: minPaymentAmount,
            paymentAmountFull: selectedOption,
            caseSotId,
            receiptDetail,
            caseType,
          })
        )
        localStorage.setItem('addAnotherCaseClicked', 'casePayment')
        history.push(`/${i18n.language}${t('routes.case_info')}`)
      }
    }
  }

  const validateFields = () => {
    try {
      let isAmountValid = false
      if (paymentAmount === '') {
        setPaymentAmountValid(isAmountValid)
        setPaymentAmountErrorPart1('case_payment_information.payment_amount_error')
      } else {
        isAmountValid = validatePaymentAmount(paymentAmount)
      }
      return isAmountValid
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validatePaymentAmount = (amountElem) => {
    try {
      let isAmountValid = false
      let error1 = '',
        error2 = '',
        errorNumber = ''
      const regex = RegExp(/^[0-9.]+$/)
      if (amountElem !== '') {
        if (regex.test(amountElem) && amountElem.split('.').length < 3) {
          if (amountElem.includes('.') ? amountElem.split('.').slice(-1)[0].length < 3 : true) {
            if (parseFloat(amountElem) >= parseFloat(minPaymentAmount) && parseFloat(amountElem) <= parseFloat(amountOwing)) {
              isAmountValid = true
            } else {
              error1 = 'case_payment_information.payment_amount_error_lesser_greater_part1'
              errorNumber = getAmountString(minPaymentAmount)
              error2 = 'case_payment_information.payment_amount_error_lesser_greater_part2'
            }
          } else {
            error1 = 'case_payment_information.payment_amount_error_decimal'
          }
        } else {
          error1 = 'case_payment_information.payment_amount_error_invalid'
        }
      } else {
        error1 = 'case_payment_information.payment_amount_error'
      }
      setPaymentAmountValid(isAmountValid)
      setPaymentAmountErrorPart1(error1)
      setPaymentAmountErrorNumber(errorNumber)
      setPaymentAmountErrorPart2(error2)
      return isAmountValid
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const getAmountString = (num) => {
    try {
      return i18n.language === 'en' ? `$ ${num}` : `${num.toString().replace('.', ',')} $`
    } catch (e) {
      console.log(e)
    }
  }

  return (
    <div>
      <div className="container">
        <BackAnchor />
        <div className="row">
          <div className="col-xs-12 col-lg-12">
            <h1>{t('case_payment_information.your_restitution_details')}</h1>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-lg-6">
            <p style={{ margin: '0' }}>
              <strong>{t('case_payment_information.case_number')}</strong>
            </p>
            <p style={{ margin: '0' }}>{editCaseNumber ? editCaseNumber : caseNumber}</p>
          </div>
        </div>
        <div className="row" style={{ marginTop: '10px' }}>
          <div className="col-xs-12 col-lg-8">
            <p style={{ margin: '0' }}>
              <strong>{t('case_payment_information.amount_owing')}</strong>
            </p>
            <p style={{ margin: '0' }}>{getAmountString(amountOwing)}</p>
          </div>
        </div>
        <div className="row" style={{ marginTop: '10px' }}>
          <div className="col-xs-12 col-lg-8">
            {paymentAmountFull === 'final' ? (
              <InfoDisplay />
            ) : (
              <PaymentAmount
                selectedOption={selectedOption}
                setSelectedOption={setSelectedOption}
                selectedOptionValid={selectedOptionValid}
                setSelectedOptionValid={setSelectedOptionValid}
                validatePaymentAmount={validatePaymentAmount}
                paymentAmountErrorPart1={paymentAmountErrorPart1}
                paymentAmountErrorNumber={paymentAmountErrorNumber}
                paymentAmountErrorPart2={paymentAmountErrorPart2}
                paymentAmountValid={paymentAmountValid}
                setPaymentAmountValid={setPaymentAmountValid}
                setIsError={setIsError}
              />
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-lg-8">
            <div
              className={styles['back_next_margin']}
              style={{ display: 'flex', alignItems: 'center', marginTop: '-30px', marginBottom: '-30px' }}
            >
              <BackNextButtons props={backNextProps} nextOnClick={onNext} displayBack={false} />
              <button className={['btn-lg btn-default-transparent']} style={{ marginLeft: '10px' }} onClick={addAnotherCase}>
                {t('case_payment_information.add_case')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withTranslation('common')(CasePaymentInformationView)
